import { render, staticRenderFns } from "./ProfileInfoAssignment.vue?vue&type=template&id=546bc8f5&scoped=true&"
import script from "./ProfileInfoAssignment.vue?vue&type=script&lang=ts&"
export * from "./ProfileInfoAssignment.vue?vue&type=script&lang=ts&"
import style0 from "./ProfileInfoAssignment.vue?vue&type=style&index=0&id=546bc8f5&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "546bc8f5",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VRow})
